/**
 * @描述 小程序相关接口
 */
const sysMiniprogram = {
  getJumpChannel: ['/lt-web/mini/program/half/jump/channel'], // 获取H5跳转小程序的链接
  getSchemeUrl: ['/lt-web/mini/program/getSchemeUrl'] // 获取跳转小程序渠道码
}

export default sysMiniprogram
